module.exports = __webpack_public_path__ + "static/withanchoring_withoutlines-3954fad1f7afad429a0973098a0177a5.gif";